var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.1733C0 9.12765 8.95431 0.17334 20 0.17334C31.0457 0.17334 40 9.12765 40 20.1733C40 31.219 31.0457 40.1733 20 40.1733C8.95431 40.1733 0 31.219 0 20.1733Z",
    fill: "#FFEAE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2269 9.99756H20.8563V23.6207C20.8563 25.2439 19.56 26.5773 17.9467 26.5773C16.3335 26.5773 15.0371 25.2439 15.0371 23.6207C15.0371 22.0266 16.3046 20.7222 17.8603 20.6642V17.2439C14.4321 17.3019 11.6665 20.1135 11.6665 23.6207C11.6665 27.157 14.4897 29.9976 17.9755 29.9976C21.4613 29.9976 24.2845 27.128 24.2845 23.6207V16.6352C25.5521 17.5628 27.1077 18.1135 28.7498 18.1425V14.7222C26.2147 14.6352 24.2269 12.5483 24.2269 9.99756Z",
    fill: "#FFEAE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_1169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 9.99756)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.4d0aff619914e461abf48e57034ccad1.svg";
export { ForwardRef as ReactComponent };